import React, { useState, useEffect, useRef } from 'react';
import MenuExteriorView from './MenuExteriorView';
import MenuInterierView from './MenuInterierView';
import AnimationBtn from './AnimationBtn';
import MenuSoftware from './MenuSoftware';
import Howtousenew from './Howtousenew';
import HowToUse from './HowToUse';
import FooterControl from './FooterControl';
import FooterControlMob from './FooterControlMob';
import Hidden from '@material-ui/core/Hidden';
import Button from '@material-ui/core/Button';

// import MenuBtn from './MenuBtn';
// import { MicNone } from '@material-ui/icons';
var mob = (navigator.userAgent.indexOf("iPhone") != -1) || ((navigator.userAgent.indexOf("Android") != -1) || (navigator.userAgent.indexOf("Mobile") != -1)) || (navigator.userAgent.indexOf('iPod') != -1) || (navigator.userAgent.indexOf('iPad') != -1) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Safari/605.1.15");
var mobPortrait = (mob && window.innerHeight > window.innerWidth);
var moblandscap = (mob && window.innerWidth > window.innerHeight);
var isipad = navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (navigator.userAgent.indexOf("iPhone") == -1);

export const userContext = React.createContext();

// var prevCounter = 0;
// var nextClicked = false;
// var prevClicked = false;

var buttonSeq = ['onResetMode', 'onExteriorClick', 'FrontModeClick', 'RearModeClick', 'onInterirorClick', 'onProcessorClick', 'onMemoryClick', 'onSoftwareClick', 'onEmbededClick', 'onOpenManageClick'];

const MainMenu = (props) => {
   const [expandedPanel, setExpandedPanel] = useState(false);


   const [animValue, setAnimValue] = useState("on");

   const [animValue1, setAnimValue1] = useState("on");



   const handleAccordionChange = (panel) => (event, isExpanded) => {
      //console.log({ event,isExpanded });
      //setExpandedPanel(isExpanded ? panel  : false );

      if (isExpanded) {
         setExpandedPanel(panel);

      } else {
         setExpandedPanel(false)
      };
      // resetBacklitCloseImg();
      // console.log('in expanded things')
      if (window.innerHeight < 720) {
         if (isExpanded == true && panel == 'panel3') {
            if (document.querySelector("#logoIntelDiv") != null) {
               if (window.mob == true && window.innerHeight < window.innerWidth) {
                  document.querySelector("#logoIntelDiv").style.position = 'initial';
                  document.querySelector("#logoIntelDiv").style.bottom = '450px';
               } else {
                  document.querySelector("#logoIntelDiv").style.position = 'initial';
               }

            }
         } else {
            if (document.querySelector("#logoIntelDiv") != null) {
               document.querySelector("#logoIntelDiv").style.position = 'fixed';
            }
         }
      } else {
         if (document.querySelector("#logoIntelDiv") != null && !window.isipad) {
            document.querySelector("#logoIntelDiv").style.position = 'fixed';
         }
      }


   };
   const [camData, setCamData] = useState("");
   var animationSwitch = window.Animation;
   var animTime = 1;
   var animTimes = 1;


   const getData = () => {
      fetch('./model_gl/config.json')
         .then(function (response) {
            return response.json();
         })
         .then(function (myJson) {
            // console.log(myJson.positions);
            setCamData(myJson.positions);
         });
   }
   useEffect(() => {
      getData();
      window.getLangTranscript();
      animationSwitch = window.Animation;
      moblandscap = (mob && window.innerWidth > window.innerHeight);

      window.position = 'reset';
      return () => {
         return false
      }
   }, []);

   useEffect((event) => {
      if (event) {
         if (event.keyCode === 13) {
            this.click();
         }
      }

      return () => {
         return false
      }

   }, [])
   useEffect((event) => {
      if (event) {
         if (event.keyCode === 13) {
            this.click();
         }
      }
      return () => {
         return false
      }

   })
   // const [animStoped,setanimStoped] = useState(true);



   //For Animation Switch 
   // console.log('animationSwitch anim', animationSwitch)

   if (animationSwitch == 'on') { animTime = 1000; animTimes = 2000 }
   else { animTime = 1; animTimes = 1 }
   // console.log('animTime', animTime)

   //new camera function
   const GotoPosInTimeNamedValue = (gotoposname, onComplete, onSample) => {
      // below code is updated in it.  
      // updated code ends here 

      var opt = undefined, gp = camData[gotoposname];

      // console.log(gotoposname)
      if (gp.fovy && window.scene.fovy != gp.fovy)
         opt = { fovy: gp.fovy };
      if (gp.pos.length > 5) {
         if (!opt)
            opt = {};
         opt.zang = gp.pos[5];
      }
      // console.log('animationSwitch', animationSwitch)
      if (animationSwitch == 'off') {
         gp.time = 1
         // console.log('animationSwitch iffff', gp.time)
      }
      else {
         gp.time = animTime;
         // console.log('animationSwitch elseeee', gp.time)
      }
      if (window.isMac && !(window.mob || window.isipad)) {
         // console.log('isImac')
         window.scene.gotoPosInTime(gp.pos[0], gp.pos[1], gp.pos[2], gp.pos[3], gp.pos[4] + 20, gp.time, onComplete, onSample, opt);
      }
      else if (window.mob) {
         // console.log('mob')
         window.scene.gotoPosInTime(gp.pos[0], gp.pos[1], gp.pos[2], gp.pos[3], gp.pos[4] + 70, gp.time, onComplete, onSample, opt);
      }
      else if (window.isipad) {
         // console.log('isipad')
         window.scene.gotoPosInTime(gp.pos[0], gp.pos[1], gp.pos[2], gp.pos[3], gp.pos[4] + 76, gp.time, onComplete, onSample, opt);
      }
      else if (window.innerWidth >= 1200 && window.innerWidth <= 1300 && !window.isipad) {
         // console.log('window.innerWidth <= 1280 && window.innerHeight<= 768')
         window.scene.gotoPosInTime(gp.pos[0], gp.pos[1], gp.pos[2], gp.pos[3], gp.pos[4] + 90, gp.time, onComplete, onSample, opt);
      }
      else {
         // console.log('desk')
         window.scene.gotoPosInTime(gp.pos[0], gp.pos[1], gp.pos[2], gp.pos[3], gp.pos[4], gp.time, onComplete, onSample, opt);
      }


   }
   //end
   const slowInOut = (x) => {
      var a = 2.1;
      var x2 = 1.0 - x;
      var px = Math.pow(x, a);
      var px2 = Math.pow(x2, a);

      return px / (px + px2);
   }

   const clearSlideSetTimeout = useRef(null);

   const sliderRangeBarUpdate = () => {
      let slider = document.getElementById("sliderRange");
      if (slider !== null) {
         slider.value = window.scene._nav.getZoomFactor();
         clearSlideSetTimeout.current = setTimeout(() => {
            slider.value = window.scene._nav.getZoomFactor()
         }, 1000);
      }
   }

   // let animArray = ['TOp','Internal_Cover_Anim','Bezel','HDD38','pasted__HDD39','Fan_01','Fan_02','Fan_03','Fan_04','Fan_05','Fan_06','Ram_AnimRam_Anim','HEATSINK.004'];

   // const stopAnim = () => {
   //    animArray.forEach(function (animName) {
   //       if (window.scene.animIsPlaying(animName)) window.scene.getAnim(animName).stop();
   //       window.scene.animPlayInTime(animName,0,0);
   //       //console.log(animName);
   //    });
   //    window.scene.clearRefine();
   // }

   const reverseAll = () => {

      // stopAnim();

      clearTimeout(clearSlideSetTimeout.current);

      for (let alreadySelected of document.querySelectorAll('.MuiAccordionDetails-root.active,.MuiAccordionDetails-root.select')) {
         if (alreadySelected !== null) {
            alreadySelected.classList.remove('active', 'select');
         }
      }

      for (let hotspot of document.querySelectorAll(".hotspots")) {
         if (hotspot !== null) {
            hotspot.style.display = 'none';
            hotspot.setAttribute('tabindex', -1);
         }
      }

      for (let hideId of ["openManagmentTool", "embadedManagment", "hybridTool"]) {
         if (document.getElementById(hideId) !== null) {
            document.getElementById(hideId).style.display = 'none';
         }
      }
      // window.document.getElementById("performance").style.display = 'none';
      window.position = 'reset';
      window.hotspot = '';
      if (!(window.mob || window.isipad)) {
         window.scene._nav._navMaxDolly = 27;
      } else {
         window.scene._nav._navMaxDolly = 37;
      }
      window.scene._nav._panMax = [16, 15];    //[left, bottom];
      window.scene._nav._panMin = [-16, -10];  //[right, top];
      // window.scene._nav.tempfRotMinLimit = 0.001;

      window.document.getElementById("performance").style.display = 'none';
      window.scene.groupApplyState("Internals_ON");
      window.scene.groupApplyState("Top_Panel_ON");
      window.scene.groupApplyState("Heatsink_ON");
      window.scene.groupApplyState("Rear_ON");
      window.scene.groupApplyState("Ref_GP_ON");
      window.scene.animPlayInTime("Heatsink_dupl1", 0.0416667, 0);
      window.scene.animPlayInTime("Top_Panel", 0.0416667, 0);
      window.scene.animPlayInTime("MX760c", 0.0416667, 0);
      document.getElementById('intHeader').style.display = 'none';
      document.getElementById('dm-Enclosure').style.display = 'none';

      window.scene.clearRefine();
   }

   const previousAndNextView = (value) => {
      if (!(mob || isipad)) {
         let previous = document.getElementById('previousView');
         if (previous !== null) {
            previous.setAttribute('aria-label', value);
         }
         let next = document.getElementById('nextView');
         if (next !== null) {
            next.setAttribute('aria-label', value);
         }
      }
   }



   /* { Menu Exterior } */
   const onExteriorClick = (isNextPrevious) => {
      // console.log('onExteriorClick');

      /* { Current Selected } */
      // setSelectedButton('onExteriorClick');
      window.selectedButtonG = 'onExteriorClick'
      window.animCheck = false
      /* { Reverse all } */
      reverseAll();

      /* { Previous and Next setattritube update value here } */
      previousAndNextView('Exterior view');

      if (document.getElementById('exteriorViewBtn') !== null) {
         document.getElementById('exteriorViewBtn').classList.add('active');
      }
      window.scene.groupApplyState("Heatsink_OFF");
      GotoPosInTimeNamedValue(window.config.front, function () {
         sliderRangeBarUpdate();

      });

      window.RT_RecordEvent("Exterior", "Exterior View", window.config.name);
      window.scene.clearRefine();
   }


   const FrontModeClick = (isNextPrevious) => {

      // console.log('FrontModeClick')

      /* { Current Selected } */
      // setSelectedButton('FrontModeClick');
      window.selectedButtonG = 'FrontModeClick'

      /* { Reverse all } */
      reverseAll();
      /* { Previous and Next setattritube update value here } */
      previousAndNextView('Front view');

      if (document.getElementById('frontBtn') !== null) {
         document.getElementById('frontBtn').classList.add('active');
      }
      window.scene.groupApplyState("Heatsink_OFF");
      GotoPosInTimeNamedValue(window.config.front, function () {
         sliderRangeBarUpdate();
         window.hotspot = 'front';

         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }
      });

      if (!(window.isipad || window.mob)) {
         for (let i = 3; i <= document.querySelectorAll(".hotspots").length; i++) {
            if (i === 7) break;
            if (window.document.getElementById("hotspot" + i) !== null) {
               window.document.getElementById("hotspot" + i).setAttribute('tabindex', 1);
            }
         }
      }
      window.RT_RecordEvent("Exterior", "Front", window.config.name);
      window.scene.clearRefine();

   }

   const RearModeClick = (isNextPrevious) => {

      // console.log('RearModeClick')

      /* { Current Selected } */
      // setSelectedButton('RearModeClick');
      window.selectedButtonG = 'RearModeClick'

      /* { Reverse all } */
      reverseAll();
      /* { Zoombar update } */


      /* { Previous and Next setattritube update value here } */
      previousAndNextView('Rear view');

      if (document.getElementById('rearBtn') !== null) {
         document.getElementById('rearBtn').classList.add('active');
      }

      window.scene.groupApplyState("Heatsink_OFF");
      window.scene.groupApplyState("Rear_OFF");
      GotoPosInTimeNamedValue(window.config.rear, function () {
         sliderRangeBarUpdate();
         window.hotspot = 'rear';
         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }
      });

      if (!(window.isipad || window.mob)) {
         for (let i = 8; i <= document.querySelectorAll(".hotspots").length; i++) {
            if (i === 15) break;
            if (window.document.getElementById("hotspot" + i) !== null) {
               window.document.getElementById("hotspot" + i).setAttribute('tabindex', 1);
            }
         }
      }

      window.RT_RecordEvent("Exterior", "Rear", window.config.name);

      window.scene.clearRefine();

   }

   /* { Menu Interior } */
   const onInterirorClick = (isNextPrevious) => {

      // console.log('onInterirorClick')

      /* { Current Selected } */
      // setSelectedButton('onInterirorClick');
      window.selectedButtonG = 'onInterirorClick'
      // window.animCheck = true;
      /* { Reverse all } */
      reverseAll();
     
      window.scene._nav._panMax = [22, 10];    //[left, bottom];
      window.scene._nav._panMin = [-16, -8];  //[right, top];

      /* { Previous and Next setattritube update value here } */
      previousAndNextView('Interior view');

      if (document.getElementById('positionBtn') !== null) {
         document.getElementById('positionBtn').classList.add('active');
      }
      // window.scene._nav.tempfRotMinLimit = -0.01;
      
      // GotoPosInTimeNamedValue(window.config.interior, function () {
      //    window.hotspot = 'interior';
      //    document.getElementById('intHeader').style.display = 'none';
      //    window.scene.animPlayInTime("MX760c", 0.4160000, animTime, function () {
      //       sliderRangeBarUpdate();
      //       window.scene.animPlayInTime("Top_Panel", 1.2500000, 2000, function () {
      //          window.scene.groupApplyState("Top_Panel_OFF");
      //          window.scene.groupApplyState("Ref_GP_OFF");
      //       });
      //       window.document.getElementById("performance").style.display = 'block';
      //    });
      //    // interiorAnim();
      // });
      window.scene.groupApplyState("Rear_OFF");
      GotoPosInTimeNamedValue(window.config.interior, function () {
         window.hotspot = 'interior';
         document.getElementById('intHeader').style.display = 'none';
        
         window.scene.animPlayInTime("Top_Panel", 1.2500000, 2000, function () {
            sliderRangeBarUpdate();       
               window.scene.groupApplyState("Ref_GP_OFF");
               window.scene.groupApplyState("Top_Panel_OFF");
            });
            window.document.getElementById("performance").style.display = 'block';
         // interiorAnim();
      });
 
      window.scene.clearRefine();

   }

   const onProcessorClick = (isNextPrevious) => {

      // console.log('onProcessorClick');
      window.selectedButtonG = 'onProcessorClick'
      reverseAll();
      window.scene._nav._panMax = [22, 10];    //[left, bottom];
      window.scene._nav._panMin = [-16, -8];  //[right, top];
      // window.scene._nav.tempfRotMinLimit = -0.01;
      window.scene.groupApplyState("Top_Panel_OFF");
      window.scene.groupApplyState("Ref_GP_OFF");
      // window.scene.animPlayInTime("MX760c", 0.4160000, 0);
      clearTimeout(clearSlideSetTimeout.current);

      for (let alreadySelected of document.querySelectorAll('.MuiAccordionDetails-root.active,.MuiAccordionDetails-root.select')) {
         if (alreadySelected !== null) {
            alreadySelected.classList.remove('active', 'select');
         }
      }

      for (let hotspot of document.querySelectorAll(".hotspots")) {
         if (hotspot !== null) {
            hotspot.style.display = 'none';
            hotspot.setAttribute('tabindex', -1);
         }
      }

      for (let hideId of ["openManagmentTool", "embadedManagment", "hybridTool"]) {
         if (document.getElementById(hideId) !== null) {
            document.getElementById(hideId).style.display = 'none';
         }
      }
      // window.document.getElementById("performance").style.display = 'none';
      window.position = 'reset';
      window.hotspot = '';
      

      document.getElementById('intHeader').style.display = 'none';
      document.getElementById('dm-Enclosure').style.display = 'none';

      previousAndNextView('Processor');

      if (document.getElementById('processorBtn') !== null) {
         document.getElementById('processorBtn').classList.add('active');
      }
      // window.scene.groupApplyState("Top_Cover_OFF");
      // GotoPosInTimeNamedValue(window.config.processor, function () {
      //    sliderRangeBarUpdate();
      //    window.scene.animPlayInTime("Heatsink_dupl1", 2.5000000, 1000, function () {
      //       window.scene.groupApplyState("Heatsink_OFF");
      //       window.hotspot = 'processor';
      //    });

      //    if (isNextPrevious != true) {
      //       window.document.getElementById("hotspot1demo").focus();
      //    }
      //    if (!(window.isipad || window.mob)) {
      //       document.getElementById("hotspot19").setAttribute("tabindex", 1);
      //    }
      // });
      window.scene.groupApplyState("Heatsink_OFF");
      GotoPosInTimeNamedValue(window.config.processor, function () {
         sliderRangeBarUpdate();
           
            window.hotspot = 'processor';
         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }
         if (!(window.isipad || window.mob)) {
            document.getElementById("hotspot19").setAttribute("tabindex", 1);
         }
      });

      window.RT_RecordEvent("Interior", "Processor", window.config.name);
      window.scene.clearRefine();
   }

   const onMemoryClick = (isNextPrevious) => {

      // console.log('onMemoryClick')

      /* { Current Selected } */
      // setSelectedButton('onMemoryClick');
      window.selectedButtonG = 'onMemoryClick'

      /* { Reverse all } */
      reverseAll();
      window.scene._nav._panMax = [22, 10];    //[left, bottom];
      window.scene._nav._panMin = [-16, -8];  //[right, top];
      // window.scene._nav.tempfRotMinLimit = -0.01;
      // window.scene.animPlayInTime("MX760c", 0.4160000, 0);
      window.scene.groupApplyState("Top_Panel_OFF");
      window.scene.groupApplyState("Ref_GP_OFF");
      /* { Previous and Next setattritube update value here } */
      previousAndNextView('Memory');

      if (document.getElementById('memoryBtn') !== null) {
         document.getElementById('memoryBtn').classList.add('active');
      }
      window.scene.groupApplyState("Top_Cover_OFF");
      GotoPosInTimeNamedValue(window.config.processor, function () {
         /* { Zoombar update } */
         sliderRangeBarUpdate();
         window.hotspot = 'memory';
         sliderRangeBarUpdate();
         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }
      });
      if (!(window.isipad || window.mob)) {
         document.getElementById("hotspot20").setAttribute("tabindex", 1);
      }
      window.RT_RecordEvent("Interior", "Memory", window.config.name);
      window.scene.clearRefine();
   }


   // const onFanClick = (isNextPrevious) => {

   //    console.log('onFanClick')

   //    /* { Current Selected } */
   //    // setSelectedButton('onFanClick');
   //    window.selectedButtonG = 'onFanClick'

   //    reverseAll();

   //    window.scene._nav._panMax = [16, 15];    //[left, bottom];
   //    window.scene._nav._panMin = [-42, -10];  //[right, top];
   //    /* { Previous and Next setattritube update value here } */
   //    previousAndNextView('DMEnclosure');

   //    if (document.getElementById('DMEnclosure') !== null) {
   //       document.getElementById('DMEnclosure').classList.add('active');
   //    }
   //    window.scene.animPlayInTime("MX760c", 0.4160000, 0);
   //    window.scene.groupApplyState("Top_Panel_OFF");

   //    GotoPosInTimeNamedValue(window.config.fans, function () {
   //       /* { Zoombar update } */
   //       sliderRangeBarUpdate();

   //       window.hotspot = 'fan';
   //       document.getElementById('dm-Enclosure').style.display = "none"

   //       // window.scene.animPlayInTime("MX760c", 0.4160000, animTime, function () {
   //       sliderRangeBarUpdate();
   //       // });
   //       if (isNextPrevious != true) {
   //          window.document.getElementById("hotspot1demo").focus();
   //       }
   //    });

   //    if (!(window.isipad || window.mob)) {
   //       document.getElementById("hotspot21").setAttribute("tabindex", 1);
   //    }
   //    window.RT_RecordEvent("Interior", "Dynamic Media Enclosure", window.config.name);

   //    window.scene.clearRefine();

   // }

   /* { Menu Software } */
   const onSoftwareClick = (isNextPrevious) => {

      // console.log('onSoftwareClick')

      /* { Current Selected } */
      // setSelectedButton('onSoftwareClick');
      window.selectedButtonG = 'onSoftwareClick'
      /* { Reverse all } */
      window.animCheck = false;
      reverseAll();
      // if (!(window.mob || window.isipad)) {
      //    window.scene._nav._navMaxDolly = 30;
      // }

      window.dellLogoFix = true;

      /* { Previous and Next setattritube update value here } */
      previousAndNextView('Software');

      if (document.getElementById('feature') !== null) {
         document.getElementById('feature').classList.add('active');
      }
      GotoPosInTimeNamedValue(window.config.front, function () {
         /* { Zoombar update } */
         sliderRangeBarUpdate();
      });

      window.scene.clearRefine();

   }

   const onEmbededClick = (isNextPrevious) => {

      // console.log('onEmbededClick')

      /* { Current Selected } */
      // setSelectedButton('onEmbededClick');
      window.selectedButtonG = 'onEmbededClick'

      /* { Reverse all } */
      reverseAll();
      if (!(window.mob || window.isipad)) {
         window.scene._nav._navMaxDolly = 35;
      } else {
         window.scene._nav._navMaxDolly = 45;
      }
      window.scene._nav._panMax = [20, 5];    //[left, bottom];
      window.scene._nav._panMin = [-16, -10];


      /* { Previous and Next setattritube update value here } */
      previousAndNextView('Intelligent Automation');

      if (document.getElementById('iAutomation') !== null) {
         document.getElementById('iAutomation').classList.add('active');
      }

      GotoPosInTimeNamedValue(window.config.insideSoftware, function () {
         /* { Zoombar update } */
         sliderRangeBarUpdate();
         if (window.mob || window.isipad) {
            window.hotspot = 'iAutomation';
         } else {
            document.getElementById("iAutomationTool").style.display = 'block';
         }
         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo2").focus();
         }

      });

      if (!(window.isipad || window.mob)) {

         document.getElementById("hotspot1").setAttribute("tabindex", "-1");
         document.getElementById("hotspot2").setAttribute("tabindex", "-1");
         document.getElementById("hotspot3").setAttribute("tabindex", "-1");
         document.getElementById("hotspot4").setAttribute("tabindex", "-1");
         document.getElementById("hotspot5").setAttribute("tabindex", "-1");
         document.getElementById("hotspot6").setAttribute("tabindex", "-1");
         document.getElementById("hotspot7").setAttribute("tabindex", "-1");
         document.getElementById("hotspot8").setAttribute("tabindex", "-1");
         document.getElementById("hotspot9").setAttribute("tabindex", "-1");
         document.getElementById("hotspot10").setAttribute("tabindex", "-1");
         document.getElementById("hotspot11").setAttribute("tabindex", "-1");
         document.getElementById("hotspot12").setAttribute("tabindex", "-1");
         document.getElementById("hotspot13").setAttribute("tabindex", "-1");
         document.getElementById("hotspot14").setAttribute("tabindex", "-1");
         document.getElementById("hotspot15").setAttribute("tabindex", "-1");
         document.getElementById("hotspot16").setAttribute("tabindex", "-1");
         document.getElementById("hotspot17").setAttribute("tabindex", "-1");
         document.getElementById("hotspot18").setAttribute("tabindex", "-1");


         document.getElementById("rLeft").setAttribute("tabindex", "0");
         document.getElementById("rRight").setAttribute("tabindex", "0");
         document.getElementById("zoomOut").setAttribute("tabindex", "0");
         document.getElementById("sliderRange").setAttribute("tabindex", "0");
         document.getElementById("zoomIn").setAttribute("tabindex", "0");
         document.getElementById("previousView").setAttribute("tabindex", "0");
         document.getElementById("resetView").setAttribute("tabindex", "0");
         document.getElementById("nextView").setAttribute("tabindex", "0");

      }

      window.RT_RecordEvent("Software", "Intelligent Automation", window.config.name);

      window.scene.clearRefine();

   }

   const onOpenManageClick = (isNextPrevious) => {

      // console.log('onOpenManageClick')

      /* { Current Selected } */
      // setSelectedButton('onOpenManageClick');
      window.selectedButtonG = "onOpenManageClick"
      /* { Reverse all } */
      reverseAll();

      if (!(window.mob || window.isipad)) {
         window.scene._nav._navMaxDolly = 35;
      } else {
         window.scene._nav._navMaxDolly = 45;
      }
      window.scene._nav._panMax = [20, 5];    //[left, bottom];
      /* { Previous and Next setattritube update value here } */
      previousAndNextView('Cyber Resiliency');

      if (document.getElementById('cResiliency') !== null) {
         document.getElementById('cResiliency').classList.add('active');
      }

      GotoPosInTimeNamedValue(window.config.insideSoftware, function () {

         /* { Zoombar update } */
         sliderRangeBarUpdate();
         (window.mob || window.isipad) && (window.hotspot = 'cResiliency');
         !(window.mob || window.isipad) && (document.getElementById("cResiliencyTool").style.display = 'block')

         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo2").focus();
         }
      });

      if (!(window.isipad || window.mob)) {

         document.getElementById("hotspot1").setAttribute("tabindex", "-1");
         document.getElementById("hotspot2").setAttribute("tabindex", "-1");
         document.getElementById("hotspot3").setAttribute("tabindex", "-1");
         document.getElementById("hotspot4").setAttribute("tabindex", "-1");
         document.getElementById("hotspot5").setAttribute("tabindex", "-1");
         document.getElementById("hotspot6").setAttribute("tabindex", "-1");
         document.getElementById("hotspot7").setAttribute("tabindex", "-1");
         document.getElementById("hotspot8").setAttribute("tabindex", "-1");
         document.getElementById("hotspot9").setAttribute("tabindex", "-1");
         document.getElementById("hotspot10").setAttribute("tabindex", "-1");
         document.getElementById("hotspot11").setAttribute("tabindex", "-1");
         document.getElementById("hotspot12").setAttribute("tabindex", "-1");
         document.getElementById("hotspot13").setAttribute("tabindex", "-1");
         document.getElementById("hotspot14").setAttribute("tabindex", "-1");
         document.getElementById("hotspot15").setAttribute("tabindex", "-1");
         document.getElementById("hotspot16").setAttribute("tabindex", "-1");
         document.getElementById("hotspot17").setAttribute("tabindex", "-1");
         document.getElementById("hotspot18").setAttribute("tabindex", "-1");


         document.getElementById("rLeft").setAttribute("tabindex", "0");
         document.getElementById("rRight").setAttribute("tabindex", "0");
         document.getElementById("zoomOut").setAttribute("tabindex", "0");
         document.getElementById("sliderRange").setAttribute("tabindex", "0");
         document.getElementById("zoomIn").setAttribute("tabindex", "0");
         document.getElementById("previousView").setAttribute("tabindex", "0");
         document.getElementById("resetView").setAttribute("tabindex", "0");
         document.getElementById("nextView").setAttribute("tabindex", "0");

      }

      window.RT_RecordEvent("Software", "Cyber Resiliency", window.config.name);

      window.scene.clearRefine();

   }



   /* { Reset } */
   const resetMode = () => {
      // setSelectedButton('onResetMode');
      window.selectedButtonG = "onResetMode"
      window.hotspot = '';
      GotoPosInTimeNamedValue(window.config.reset);
   }

   const menuSelectedButton = (menuSelectItem, expandedPanel = false) => {

      //console.log(menuSelectItem + ' ' + expandedPanel);
      // console.log('menuSelectItem',menuSelectItem)
      if (menuSelectItem === 'onExteriorClick') {
         expandedPanel && setExpandedPanel("panel2");
         onExteriorClick(true);
      }
      else if (menuSelectItem === 'FrontModeClick') {
         expandedPanel && setExpandedPanel("panel2");
         FrontModeClick(true);
      }
      else if (menuSelectItem === 'RearModeClick') {
         expandedPanel && setExpandedPanel("panel2");
         RearModeClick(true);
      }
      else if (menuSelectItem === 'onInterirorClick') {
         expandedPanel && setExpandedPanel("panel5");
         onInterirorClick(true);
      }
      else if (menuSelectItem === 'onProcessorClick') {
         expandedPanel && setExpandedPanel("panel5");
         onProcessorClick(true);
      }
      else if (menuSelectItem === 'onMemoryClick') {
         expandedPanel && setExpandedPanel("panel5");
         onMemoryClick(true);
      }


      // else if (menuSelectItem === 'onFanClick') {
      //    expandedPanel && setExpandedPanel("panel5");
      //    onFanClick(true);
      // }
      else if (menuSelectItem === 'onSoftwareClick') {
         expandedPanel && setExpandedPanel("panel3");
         onSoftwareClick(true);
      }
      else if (menuSelectItem === 'onEmbededClick') {
         expandedPanel && setExpandedPanel("panel3");
         onEmbededClick(true);
      }
      else if (menuSelectItem === 'onOpenManageClick') {
         expandedPanel && setExpandedPanel("panel3");
         onOpenManageClick();
      }
      // else if (menuSelectItem === 'BEfficiencyClick') {
      //    expandedPanel && setExpandedPanel("panel3");
      //    BEfficiencyClick(true);
      // }
      // else if (menuSelectItem === 'CModernClick') {
      //    expandedPanel && setExpandedPanel("panel3");
      //    CModernClick(true);
      // }

      else if (menuSelectItem === 'onResetMode') {
         resetMode();
      }
   }

   const onResetMode = () => {
      /* { Zoombar update } */
      sliderRangeBarUpdate();

      menuSelectedButton(window.selectedButtonG, false);
      window.scene.clearRefine();
   }

   const onPreviousMode = () => {

      /* { Zoombar update } */
      reverseAll();
      sliderRangeBarUpdate();
      if (document.getElementById("bEfficiencyTool") !== null) {
         document.getElementById("bEfficiencyTool").style.display = 'none';
      }
      if (document.getElementById("iAutomationTool") !== null) {
         document.getElementById("iAutomationTool").style.display = 'none';
      }
      if (document.getElementById("cResiliencyTool") !== null) {
         document.getElementById("cResiliencyTool").style.display = 'none';
      }
      // if (document.getElementById("cModernTool") !== null) {
      //    document.getElementById("cModernTool").style.display = 'none';
      // }
      var prevButton;

      var selectedButtonIndex = buttonSeq.findIndex(element => element === window.selectedButtonG)
      if (window.selectedButtonG === 'onExteriorClick' || window.selectedButtonG === 'onResetMode') {
         prevButton = 'onOpenManageClick';
      } else {
         prevButton = buttonSeq[selectedButtonIndex - 1];
      }

      menuSelectedButton(prevButton, true);
      return false;
   }

   const onNextMode = () => {
      // console.log('on next mode ')
      /* { Zoombar update } */
      reverseAll();
      sliderRangeBarUpdate();
      if (document.getElementById("bEfficiencyTool") !== null) {
         document.getElementById("bEfficiencyTool").style.display = 'none';
      }
      if (document.getElementById("iAutomationTool") !== null) {
         document.getElementById("iAutomationTool").style.display = 'none';
      }
      if (document.getElementById("cResiliencyTool") !== null) {
         document.getElementById("cResiliencyTool").style.display = 'none';
      }
      // if (document.getElementById("cModernTool") !== null) {
      //    document.getElementById("cModernTool").style.display = 'none';
      // }
      var nextButton;
      var selectedButtonIndex = buttonSeq.findIndex(element => element === window.selectedButtonG)
      if (window.selectedButtonG === 'onOpenManageClick') {
         nextButton = 'onExteriorClick';
      }
      else {
         nextButton = buttonSeq[selectedButtonIndex + 1];
      }
      // console.log('nextButton', nextButton)
      menuSelectedButton(nextButton, true);


      return false;
   }

   useEffect(() => {
      window.Animation = 'on';
      setAnimValue("on");
      document.getElementsByClassName('onOff')[0].style.left = "-17px";
      document.getElementById("animSwitchValue").checked = true;
      document.getElementById('animSwitchValue').setAttribute('aria-label', 'clickable checkbox checked on');


      if (!(window.mob && window.innerWidth < window.innerHeight)) {
         document.getElementById("animSwitchValue1").setAttribute('aria-label', 'Animation on');
         setAnimValue1("on");
         document.getElementById("animSwitchValue1").checked = true;
         document.getElementsByClassName('onOff1')[0].style.left = "-17px";
      }

      return () => {
         return false
      }
   }, []);

   const setAnimationSwitch = (e) => {
      //  console.log(e)
      // displayName(e);
      const isChecked = document.getElementById("animSwitchValue").checked;

      if (isChecked == true) {
         //document.getElementById("animSwitchValue").setAttribute('aria-label', 'Animation Off');
         document.getElementById("animSwitchValue").checked = false;
         setAnimValue("Off");
         document.getElementsByClassName('onOff')[0].style.left = "9px";
         window.Animation = 'off';

      } else {
         // document.getElementById("animSwitchValue").setAttribute('aria-label', 'Animation On')
         document.getElementById("animSwitchValue").checked = true;

         setAnimValue("on");
         window.Animation = 'on';
         document.getElementsByClassName('onOff')[0].style.left = "-17px";

      }
   }
   const displayName = (e) => {
      //  console.log(e)
      const isChecked = document.getElementById("animSwitchValue").checked;

      if (isChecked == true) {
         setAnimValue("on");
         window.Animation = 'on';
         document.getElementsByClassName('onOff')[0].style.left = "-17px";
         document.getElementById('animSwitchValue').setAttribute('aria-label', 'clickable checkbox checked on');
         // alert("Animation On");

      } else {
         setAnimValue("Off");
         document.getElementsByClassName('onOff')[0].style.left = "9px";
         window.Animation = 'off';
         document.getElementById('animSwitchValue').setAttribute('aria-label', 'clickable checkbox checked Off');
         // alert("Animation Off");

      }

   }
   const setAnimationSwitch1 = (e) => {

      const isChecked = document.getElementById("animSwitchValue1").checked;

      if (isChecked == true) {
         //document.getElementById("animSwitchValue").setAttribute('aria-label', 'Animation Off');
         document.getElementById("animSwitchValue1").checked = false;
         setAnimValue1("Off");
         document.getElementsByClassName('onOff1')[0].style.left = "9px";
         window.animationSwitchVal = 'off';
         window.animationSwitchGlobal = 'off';


      }
      else {
         // document.getElementById("animSwitchValue").setAttribute('aria-label', 'Animation On')
         document.getElementById("animSwitchValue1").checked = true;
         setAnimValue1("on");
         window.animationSwitchVal = 'on';
         window.animationSwitchGlobal = 'on';
         document.getElementsByClassName('onOff1')[0].style.left = "-17px";
      }
   }
   var animStopped = true;
   const displayName1 = (e) => {
      if (animStopped == false) {
         return;
         animStopped = false;
      }
      // console.log(e)
      const isChecked = document.getElementById("animSwitchValue1").checked;

      if (isChecked == true) {
         setAnimValue1("On");
         window.animation1SwitchGlobal = 'on';
         document.getElementsByClassName('onOff1')[0].style.left = "-17px";
         document.getElementById('animSwitchValue1').setAttribute('aria-label', 'clickable checkbox checked On');
         window.animationSwitchVal = 'on';

         if (window.mob) {
            document.getElementById('footerControls').removeAttribute('style');
            document.getElementById('footerControMob').style.display = 'block';
         }
         else if (window.isipad) {
            // console.log('portrait');
            document.getElementById('footerControMob').style.display = 'block';
            document.getElementById('footerControls').style.display = 'block';
         }
         else {
            //  console.log("show");

            document.getElementById('footerControls').style.transition = "bottom 0.2s linear";
            document.getElementById('footerControls').style.bottom = "20px";

            document.getElementById('footerControls').style.visibility = "";
            document.getElementById('footerControIpad').style.visibility = "";
         }


      } else {
         setAnimValue1("Off");
         document.getElementsByClassName('onOff1')[0].style.left = "9px";
         window.animation1SwitchGlobal = 'off';

         document.getElementById('animSwitchValue1').setAttribute('aria-label', 'clickable checkbox checked Off');

         if (window.mob) {
            document.getElementById('footerControls').removeAttribute('style');
            document.getElementById('footerControMob').style.display = 'none';
         } else if (window.isipad) {
            // console.log('landscape');
            document.getElementById('footerControMob').style.display = 'none';
            document.getElementById('footerControls').style.display = 'none';
         }
         else {
            // console.log("hide");
            document.getElementById('footerControls').style.transition = "bottom 0.2s linear";
            document.getElementById('footerControls').style.bottom = "-118px";
            setTimeout(function () {

               document.getElementById('footerControls').style.visibility = "hidden";
               document.getElementById('footerControIpad').style.visibility = "hidden";
               animStopped = true;
            }, 200);
         }

      }

   }

   return (
      <>
         {!mob && <HowToUse />}
         <Hidden only={['sm', 'md', 'lg', 'xl']}>

            <Button style={{ position: 'fixed', backgroundColor: '#F0F0F0', width: '100%', height: '56px', paddingTop: '15px', paddingBottom: '15px', zIndex: '1', border: '1px solid #E1E1E1', borderLeft: "none", borderRight: "none", borderRadius: "0", margin: "-1px 0px 0px 0px" }}
               variant="outlined"
               color="primary"
               // className={classes.button}
               endIcon={<img src="./img/cross.svg" alt="cross" style={{ marginLeft: '207px', height: '23px' }} />}
               onClick={props.toggleDrawerAction}
            >
              {window.finalLangues.mainmenu}
            </Button>
            <Howtousenew />

         </Hidden>
         <Hidden only={['md', 'lg', 'xl', 'xs']}>
            {moblandscap && <Howtousenew />}
         </Hidden>

         <Hidden only={["xs"]}>
            <FooterControl name="reset and next previous"
               onReset={onResetMode} onPrevious={onPreviousMode}
               onNext={onNextMode}
            />
         </Hidden>
         <Hidden only={['lg', 'xl']}>
            <FooterControlMob onResetMob={onResetMode}
               onPreviousMob={onPreviousMode} onNextMob={onNextMode}
               onResetIpad={onResetMode} onNextIpad={onNextMode}
               onPreviousIpad={onPreviousMode}
            />
         </Hidden>
         {/* <MenuSelectProductType tabIndex="1" name="Select Product Type" onclicked={laptopClick} onclickedtwo={select2in1Click} value={value} expanded={expandedPanel === 'panel5'} onChanged={handleAccordionChange('panel5')}/> */}
         {/* <userContext.Provider value=""> */}
         {/* <MenuColors id="menuColor" tabIndex="1" name="Colors" onWhiteBtnClick={color1Click} onBlackBtnClick={color2Click} expanded={expandedPanel === 'panel4'} onChanged={handleAccordionChange('panel4')} /> */}
         {/* </userContext.Provider> */}
         {/* <MenuPositions name="Adjustability" tabIndex="1" onTentMode={TentModeClick} onTheaterMode={TheaterModeClick} onTabletMode={TabletModeClick} expanded={expandedPanel === 'panel2'} onChanged={handleAccordionChange('panel2')}/> */}

         <MenuExteriorView
            name={window.finalLangues.exterior}
            tabIndex="1" onExterior={onExteriorClick}
            onFrontMode={FrontModeClick} onRearMode={RearModeClick}
            expanded={expandedPanel === 'panel2'}
            onChanged={handleAccordionChange('panel2')}
         />

         <MenuInterierView
            name={window.finalLangues.port3I} tabIndex="1"
            onProcessorBtnClick={onProcessorClick} onMemoryBtnClick={onMemoryClick}
            // onDMEnclosureClick={onFanClick}
            onInterirorBtnClick={onInterirorClick} expanded={expandedPanel === 'panel5'}
            onChanged={handleAccordionChange('panel5')}
         />

         <MenuSoftware name={window.finalLangues.software}
            tabIndex="1" onIAutomationClicked={onEmbededClick}
            onCResiliencyClicked={onOpenManageClick}
            onSoftware={onSoftwareClick}
            expanded={expandedPanel === 'panel3'}
            onChanged={handleAccordionChange('panel3')}
         />

         <AnimationBtn
            onchange={displayName}
            forKeypress={setAnimationSwitch}
            value={animValue} onchange1={displayName1}
            forKeypress1={setAnimationSwitch1} value1={animValue1}
         />

      </>
   );
}

export default MainMenu;